import React from 'react'
import cx from 'classnames'

import './ui.scss'

const Avatar = ({
  className,
  children,
  src,
  alt,
  ...props
}) => {
  const classes = cx(className, 'm-avatar')

  return (
    <span
      className={classes}
      {...props}
    >
      { src
        ? <img
            className="m-avatar__image"
            src={src}
            alt={alt}
          />
        : children }
    </span>
  )
}

export default Avatar
